import Grid from '@material-ui/core/Grid';
import { useEffect, useState } from 'react';
import {
    BoxHeader,
    BoxTitle,
} from '../../pages/home/homeElements'
import {
    Box,
    ListNews,
    NewsItem,
    NewsImageLink,
    NewsImage,
    NewsTitle,
    NewsCategory,
    ViewMore,
    NewsFlex
} from './highlightBoxElements'
import newsApi from '../../api/newsApi'

const HighlightBox = ({ category, _limit, small}) => {
    const [news, setNews] = useState({})
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const getNews = async () => {
            const response = await newsApi.getHighlightNews({ category, _limit})
            setNews(response.news)
            setLoading(false)
        }

        getNews()
    },[category, _limit])



    if(loading) return <></>


    return (
        <Box small={small}>
            <BoxHeader>
                <BoxTitle to='/'>Nổi bật</BoxTitle>
                <ViewMore to='/'>Xem thêm</ViewMore>
            </BoxHeader>
            <ListNews>
                <Grid container spacing={2}>
                    {news.map((news, index) => (
                        <Grid key={news._id} item md={_limit === 3 ? 4:3} xs={12}>
                            <NewsItem>
                                <NewsImageLink title={news.title} to={`/news/${news._id}`}>
                                    <NewsImage small={small} src={news.image} alt={news.title} />
                                </NewsImageLink>
                                <NewsFlex>
                                    <NewsTitle title={news.title} to={`/news/${news._id}`}>{news.title}</NewsTitle>
                                    <NewsCategory title={news.category} to='/'>{news.category}</NewsCategory>
                                </NewsFlex>
                            </NewsItem>
                        </Grid>
                    ))}
                </Grid>
            </ListNews>
        </Box>
    )
}

export default HighlightBox
